/* * @Author: 孙福聪 * @Date: 2019-01-16 16:02:40 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-03-25 09:22:42 */
<template lang="pug">
.userlist
  div
    Table(:columns="columns1", :data="teacherlist")
    Button(type="primary", @click="modal1 = true") + 新建
    Page.page(
      @on-change="handleCurrentChange",
      :total="pageData.totalRecords",
      :page-size="10",
      show-elevator,
      show-total
    )
      span 当前有{{ teacherlist.length }}条数据，共{{ pageData.totalRecords }}条数据
  Modal(v-model="modal1", title="添加教师", width="30")
    Form.form(
      ref="teacherForm",
      :model="teacherForm",
      :label-width="70",
      label-position="left",
      :rules="formRules",
      v-if="modal1"
    )
      FormItem(prop="code", label="账号：")
        Input(
          v-model.trim="teacherForm.code",
          placeholder="请输入账号",
          prop="code",
          :maxlength="20"
        )
      FormItem(prop="name", label="姓名：")
        Input(
          v-model="teacherForm.name",
          placeholder="请输入姓名",
          prop='name',
          :maxlength="20"
        )
      FormItem(label="密码：")
        span.span1 初始密码为{{newPassword}}
    div(slot="footer")
      Button(@click='modal1 = false') 取消
      Button(type="primary" @click="createUser('teacherForm')") 确定
  Modal(
    v-model="modal2",
    title="修改教师信息",
    width="30",
    @on-ok="editorUser('editteacherForm')"
  )
    Form.form(
      ref="editteacherForm",
      :model="editteacherForm",
      :rules="formRules",
      :label-width="70",
      label-position="left"
    )
      FormItem(prop="code", label="账号：")
        Input(
          v-model="editteacherForm.code",
          placeholder="请输入账号",
          prop="code",
          disabled
        )
      FormItem(prop="name", label="姓名：")
        Input(
          v-model="editteacherForm.name",
          placeholder="请输入姓名",
          prop='name',
          :maxlength="20"
        )
      FormItem
        Button(type="text", style="padding: 0;", @click="resetPassword") 重置密码
    div(slot="footer")
      Button(@click='modal2 = false') 取消
      Button(type="primary" @click="editorUser('editteacherForm')") 确定
  Modal.delete-user(v-model="deleteSta", :transfer="false", width="416")
    p(slot="header", style="color:#2A2E36;font-size:18px;height: 28px;")
      Icon(type="ios-alert", size="28", color="#F19D38")
      span(style="margin-left: 8px;") 系统提示
    RadioGroup(type="button", v-model="deleteUser")
      Radio(label="删除用户及其班级")
      Radio(label="删除用户并将其班级转到其他用户")
    Select(
      style="width:200px;margin: 8px;",
      v-if="deleteUser === '删除用户并将其班级转到其他用户'",
      v-model="code"
    )
      template(v-for="v in allTeacherList")
        Option(
          :key="v.code",
          :value="v.code",
          v-if="v.code !== deleteCode",
          :disabled="v.code === 'admin'"
        ) {{ v.name }}
    div(slot="footer", style="float: right;")
      Button(
        type="text",
        style="margin: 0;",
        @click="deleteSta = false; deleteUser = ''"
      ) 取消
      Button(
        type="primary",
        :loading="loading",
        style="margin: 0;",
        @click="fun_delete",
        :disabled="deleteUser === '删除用户并将其班级转到其他用户' ? code == '' || deleteUser === '' : deleteUser === ''"
      ) 确定
</template>

<script>
export default {
  data() {
    return {
      newPassword: "",
      pageData: {}, // 表格分页数据
      deleteSta: false,
      modal1: false,
      modal2: false,
      deleteCode: "", // 要删除的用户code
      deleteUser: "",
      loading: false,
      page: 1,
      listclass: "", // 教师班级ID
      className: "", // 教师的班级
      classRoom_uuid: "",
      code: "", // 接管班级的老师code
      formRules: {
        // 表单正则
        code: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_-]{1,20}$/,
            message: "账号只能为字母,下划线数字,长度不能超过20位",
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            // pattern: /^.{2,20}$/,
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: "姓名只能是数字,字母,汉字组成,不能包含特殊符号和空格,长度2-20位",
            trigger: "change"
          }
        ]
      },
      teacherForm: {
        // 模态框1数据
        code: "",
        name: ""
      },
      editteacherForm: {
        // 模态框2数据
        code: "",
        name: ""
      },
      columns1: [
        // - {
        // -   title: "序号",
        // -   type: "index"
        // - },
        {
          title: "账号",
          key: "code",
          width: 171
        },
        {
          title: "教师姓名",
          key: "name",
          width: 800
        },
        // {
        // title: "班级名称",
        // key: "className"
        // },
        {
          title: "操作",
          width: 153,
          render: (h, params) => {
            if (params.row.code !== "admin") {
              return h("div", [
                h("i", {
                  class: "icon-bianji4 iconfont",
                  fixed: "center",
                  style: "font-size:16px;color:#3A76D2",
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                }),
                h(
                  "span",
                  {
                    style: {
                      color: "#3A76D2",
                      fontSize: "14px",
                      lineHeight: "40px",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.show(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#DCDCDC",
                      padding: "0 6px"
                    }
                  },
                  "|"
                ),
                h("i", {
                  class: "icon-shanchulaji iconfont",
                  fixed: "center",
                  style: "font-size:16px;color:#3A76D2",
                  on: {
                    click: () => {
                      this.confirm(params.row);
                    }
                  }
                }),
                h(
                  "span",
                  {
                    style: {
                      color: "#3A76D2",
                      fontSize: "14px",
                      lineHeight: "40px",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.confirm(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
            return h("div", [
              h("i", {
                class: "icon-bianji4 iconfont",
                fixed: "center",
                style: "font-size:16px;color:#3A76D2",
                on: {
                  click: () => {
                    this.show(params.row);
                  }
                }
              }),
              h(
                "span",
                {
                  style: {
                    color: "#3A76D2",
                    fontSize: "14px",
                    lineHeight: "40px",
                    cursor: "pointer"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#DCDCDC",
                    padding: "0 6px"
                  }
                },
                "|"
              ),
              h("i", {
                class: "icon-shanchulaji iconfont",
                fixed: "center",
                style: "font-size:16px;color:#808080;cursor:default;"
              }),
              h(
                "span",
                {
                  style: {
                    color: "#808080",
                    fontSize: "14px",
                    lineHeight: "40px",
                    cursor: "default"
                  }
                },
                "删除"
              )
            ]);
          }
        }
        // - {
        // -   title: "编辑",
        // -   render: (h, params) => {
        // -     return h("div", [
        // -       h("i", {
        // -         class: "icon-bianji iconfont",
        // -         fixed: "center",
        // -         style: "font-size:20px",
        // -         on: {
        // -           click: () => {
        // -             this.show(params.row);
        // -           }
        // -         }
        // -       })
        // -     ]);
        // -   }
        // - }
      ],
      teacherlist: [], // 教师列表
      allTeacherList: [] // 全部教师列表
    };
  },
  methods: {
    resetPassword() {
      this.$Modal.confirm({
        title: "系统提示",
        content: `<p>你确定要把该用户的密码重置为${this.newPassword}吗?</p>`,
        onOk: () => {
          this.$http
            .resetPassword({
              code: this.editteacherForm.code,
              newPassword: this.newPassword
            })
            .then((res) => {
              if (res.data.success) {
                this.$Message.success("重置密码成功.");
              }
            });
        }
      });
    },
    fun_delete() {
      this.loading = true;
      if (this.deleteUser === "删除用户并将其班级转到其他用户") {
        this.$http
          .deleteTeacherTransfetClass({
            userCode: this.deleteCode,
            toUserCode: this.code
          })
          .then((res) => {
            console.log(res);
            if (res.data.success) {
              this.$Message.success("删除成功");
              this.getTeacherlist();
              this.getAllTeacherList();
              this.deleteSta = false;
              this.code = "";
              this.deleteUser = "";
            }
            this.loading = false;
          });
      } else {
        this.$http
          .deletingClassMember({
            isTeacher: true,
            userId: this.deleteCode,
            classRoom_uuid: this.classRoom_uuid
          })
          .then((res) => {
            if (res.data.success) {
              this.$Message.success("删除成功");
              this.getTeacherlist();
              this.code = "";
              this.deleteUser = "";
              this.deleteSta = false;
            }
            this.loading = false;
          });
      }
    },
    deletTeacher(row) {
      // 删除列表数据
      const data = {
        classRoom_uuid: this.listclass,
        userId: row.code
      };
      this.$http.deleteUser(data).then((res) => {
        if (res.data.success) {
          this.getTeacherlist(this.listclass);
        }
      });
    },
    listClassRequest() {
      // 获取班级id
      const data1 = {
        teacherCode: this.$role.code
      };
      this.$http.listClassRequest(data1).then((res) => {
        if (res.data.success) {
          if (res.data.data.list.length > 0) {
            res.data.data.list.forEach((ele) => {
              if (ele.vipClass) {
                this.listclass = ele.id;
                this.className = ele.name;
              }
            });
            this.getTeacherlist();
          }
        }
      });
    },
    handleCurrentChange(page) {
      // 分页函数
      this.page = page;
      this.getTeacherlist();
    },
    editorUser(formName) {
      // 编辑用户
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            code: this.editteacherForm.code,
            name: this.editteacherForm.name
          };
          this.$http.editorUser(data).then((res) => {
            if (res.data.success) {
              this.$Message.success("修改成功");
              this.modal2 = false;
              this.getTeacherlist();
            }
          });
        } else {
          this.$Message.error("请填写");
          return false;
        }
      });
    },
    createUser(formName) {
      // 创建用户
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            code: this.teacherForm.code,
            name: this.teacherForm.name,
            isTeacher: true
          };
          this.$http.createUser(data).then((res) => {
            if (res.data.success) {
              this.getTeacherlist();
              this.$Message.success("添加成功");

              this.modal1 = false;
              this.teacherForm = {
                code: "",
                name: ""
              };
            }
          });
        } else {
          this.$Message.error("请填写完整信息");
          return false;
        }
      });
    },
    show(row) {
      // 编辑显示模态框2
      this.editteacherForm = {
        code: row.code,
        name: row.name
      };
      this.modal2 = true;
    },
    confirm(row) {
      // 弹出确定删除模态框
      this.deleteSta = true;
      this.deleteCode = row.code;
      this.classRoom_uuid = row.classId;
      console.log(row);
      // this.$Modal.confirm({
      //   title: "系统提示",
      //   content: "<p>你确定要删除这些数据吗?</p>",
      //   onOk: () => {
      //     this.deletTeacher(row);
      //   }
      // });
    },
    getTeacherlist() {
      // 查询教师列表
      const data = {
        pageNo: this.page,
        pageSize: 10
      };
      this.$http.listUser(data).then((res) => {
        if (res.data.success) {
          console.log(res);
          this.teacherlist = res.data.data.list;
          this.pageData = res.data.data;
          this.teacherlist.forEach((e) => {
            e.className = this.className;
          });
        }
      });
    },
    getAllTeacherList() {
      this.$http.listUser({}).then((res) => {
        if (res.data.success) {
          this.allTeacherList = res.data.data.list;
        }
      });
    }
  },
  watch: {
    modal1() {
      if (!this.modal1) {
        this.teacherForm = {
          // 模态框1数据
          code: "",
          name: ""
        };
      }
    }
  },
  async created() {
    if (this.$role.role === "teacher") {
      this.$router.push({
        path: "/Teacher/classlist"
      });
    } else {
      this.getTeacherlist();
      this.getAllTeacherList();
      const { data } = await this.$http.getDefaultPassword();
      this.newPassword = data.data;
    }
  }
};
</script>

<style lang="stylus" scope>
.userlist
  overflow hidden
  .delete-user
    text-align left
    .ivu-modal-body
      height auto
    .ivu-modal-header, .ivu-modal-footer
      border none
    .ivu-radio-wrapper
      display block
      width 368px
      height 40px
      background rgba(244, 246, 248, 1)
      border-radius 4px
      margin 8px
      border none
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      line-height 40px
      &:before
        width 0
    .ivu-radio-wrapper-checked
      background rgba(74, 144, 226, 1)
      color #ffffff
      &:focus
        outline none
      &::before
        background none
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #EEF2F5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            border-top 1px solid transparent
            border-collapse unset
            box-sizing border-box
            height 40px
            &:first-child
              border-left 1px solid transparent
              border-radius 8px 0 0 8px
            &:last-child
              border-right 1px solid transparent
              border-radius 0 8px 8px 0
          &:last-child
            td
              border-bottom 1px solid transparent !important
  .ivu-table-tip
    tr
      td
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .ivu-page-total
    span
      color #999999
      font-size 14px
  .ivu-page-item-active
    background #57A3F3
    a
      color #FFFFFF
  button
    height 36px
    margin-top 30px
    float left
  .page
    margin-top 30px
    float right
  .ivu-input
    display block
    width 95%
    height 32px
  .ivu-modal-footer
    height 60px
  .ivu-btn-large
    margin-top -5px
    display block
    float right
  .span1
    font-size 14px
    color #808080
  .ivu-modal-body
    height 180px
  .ivu-modal-confirm-body
    display block
    height 50px
    margin-top 10px
  .iconfont
    cursor pointer
</style>
